export default {
      id: "crop-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#crop",
      toString: function () {
        return this.url;
      }
    }